<template>
  <div>
    <vs-card class="print-hidden">
      <div>
        <BrokerCommissionFilter @submitFilters="handleFiltersSubmit" />
      </div>
    </vs-card>
    <vs-card class="my-6" v-if="reportData">
      <div class="report-container print-only">
        <div class="flex items-center justify-between mb-8">
          <img src="../../../../assets/images/logo/logo-bpseguradora.svg" alt="Logo" class="logo"/>
          <h3 class="text-lg font-bold mx-auto">
            EXTRATO DE COMISSÃO
          </h3>
          <vs-button @click="printReport" class="print-hidden" type="filled" color="primary">
            Imprimir Relatório
          </vs-button>
        </div>

        <div class="flex items-center justify-between mb-8">
          <h3 class="text-sm font-bold">
            REFERENTE À: {{reportData.start_date}} A {{reportData.end_date}}
          </h3>
          <h3 class="text-sm font-bold mx-auto">
            CORRETORA: {{reportData.broker_name}}
          </h3>
          <h3 class="text-sm font-bold">
            SUSEP: {{reportData.broker_susep}}
          </h3>
        </div>
        <table class="w-full border-collapse mb-8 report-table-line">
          <thead class="bg-gray-200">
            <tr>
              <th class="p-2 no-border">
                <h3 class="text-sm font-bold">
                  Resumo:
                </h3>
              </th>
            </tr>
            <tr>
              <th class="border-b border-gray-400 p-2">Data Pgto. Repasse</th>
              <th class="border-b border-gray-400 p-2">CNPJ</th>
              <th class="border-b border-gray-400 p-2">Bruto</th>
              <th class="border-b border-gray-400 p-2">IRRF</th>
              <th class="border-b border-gray-400 p-2">INSS</th>
              <th class="border-b border-gray-400 p-2">ISS</th>
              <th class="border-b border-gray-400 p-2">Líquido</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in reportData.summary" :key="index">
              <td class="border-b border-gray-300 p-2">{{ item.payment_date }}</td>
              <td class="border-b border-gray-300 p-2">{{ reportData.broker_cnpj }}</td>
              <td :class="['border-b border-gray-300 p-2', { 'negative-value': isNegativeValue(item.gross_amount) }]">{{ formatReportCurrency(item.gross_amount) }}</td>
              <td :class="['border-b border-gray-300 p-2', { 'negative-value': isNegativeValue(item.irrf) }]">{{ formatReportCurrency(item.irrf) }}</td>
              <td :class="['border-b border-gray-300 p-2', { 'negative-value': isNegativeValue(item.inss) }]">{{ formatReportCurrency(item.inss) }}</td>
              <td :class="['border-b border-gray-300 p-2', { 'negative-value': isNegativeValue(item.iss) }]">{{ formatReportCurrency(item.iss) }}</td>
              <td :class="['border-b border-gray-300 p-2', { 'negative-value': isNegativeValue(item.net_amount) }]">{{ formatReportCurrency(item.net_amount, { truncate: true }) }}</td>
            </tr>
          </tbody>
        </table>

        <table class="w-full border-collapse report-table-line">
          <thead class="bg-gray-200">
            <tr>
              <th class="p-2 no-border">
                <h3 class="text-sm font-bold">
                  Detalhamento:
                </h3>
              </th>
            </tr>
            <tr>
              <th class="border-b border-gray-400 p-2">Data <br> Pgto. Repasse</th>
              <th class="border-b border-gray-400 p-2">Apólice</th>
              <th class="border-b border-gray-400 p-2 text-center">End</th>
              <th class="border-b border-gray-400 p-2">Segurado</th>
              <th class="border-b border-gray-400 p-2">Ramo</th>
              <th class="border-b border-gray-400 p-2">Prêmio <br> Líquido Total</th>
              <th class="border-b border-gray-400 p-2">Parcela</th>
              <th class="border-b border-gray-400 p-2">Prêmio <br> Líquido Pago</th>
              <th class="border-b border-gray-400 p-2">Comissão</th>
              <th class="border-b border-gray-400 p-2 text-center">Antecipado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in reportData.details" :key="index">
              <td class="border-b border-gray-300 p-2 ">{{ item.payment_date }}</td>
              <td class="border-b border-gray-300 p-2" nowrap>{{ item.policy_number }}</td>
              <td class="border-b border-gray-300 p-2 text-center">{{ item.endorsement }}</td>
              <td class="border-b border-gray-300 p-2">{{ item.insured_name }}</td>
              <td class="border-b border-gray-300 p-2">{{ item.product_line }}</td>
              <td :class="['border-b border-gray-300 p-2', { 'negative-value': isNegativeValue(item.tariff_prize) }]">{{ formatReportCurrency(item.tariff_prize) }}</td>
              <td class="border-b border-gray-300 p-2">{{ item.installment }}</td>
              <td :class="['border-b border-gray-300 p-2', { 'negative-value': isNegativeValue(item.tariff_prize_paid) }]">{{ formatReportCurrency(item.tariff_prize_paid) }}</td>
              <td :class="['border-b border-gray-300 p-2', { 'negative-value': isNegativeValue(item.commission_amount) }]" nowrap>{{ item.commission_rate }} - {{ formatReportCurrency(item.commission_amount) }}</td>
              <td class="border-b border-gray-300 p-2 text-center">{{ item.advanced }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </vs-card>
  </div>
</template>

<script>
import BrokerCommissionFilter from '../../../filtros/BrokerCommissionFilter.vue';
import autoApi from "../../../../services/auto.api";

export default {
  name: 'BrokerCommission',
  components: {
    BrokerCommissionFilter,
  },
  data() {
    return {
      showReport: false,
      reportData: null,
    };
  },
  methods: {
    handleFiltersSubmit(filters) {
      this.$vs.loading();

      autoApi
        .getBrokerCommissionReport(filters.brokerId, filters.startDate, filters.endDate)
        .then((res) => {
          this.reportData = res;
          this.showReport = true;
        })
        .catch(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro ao obter relatório de comissão',
            color: 'danger',
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    printReport() {
      window.print();
    },
    isNegativeValue(value) {
      return Number(value) < 0;
    },
    formatReportCurrency(value, { truncate = false } = {}) {
      if (value === null || value === undefined || value === '') {
        return truncate ? 'R$ 0,00' : undefined;
      }

      const numericValue = Number(value);

      if (Number.isNaN(numericValue)) {
        return 'R$ 0,00';
      }

      const absoluteValue = Math.abs(
        truncate ? Math.floor(numericValue * 100) / 100 : numericValue,
      );
      const formattedValue = absoluteValue.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      if (!this.isNegativeValue(numericValue)) {
        return formattedValue;
      }

      return `${formattedValue.replace(/^R\$\s*/, 'R$ (')})`;
    },
  },
};
</script>

<style>
@media print {
  @page :first {
    size: A4 landscape;
    margin: 8px 0;
  }

  @page {
    size: A4 landscape;
    margin: 32px 0;
  }

  .content-area-reduced {
    margin: 0 !important;
    width: 100% !important;
  }

  .vs-sidebar {
    display: none !important;
  }

  body {
    margin: 0;
    padding: 0;
  }

  body * {
    visibility: hidden;
  }

  .print-only, .print-only * {
    visibility: visible;
  }

  .print-hidden {
    display: none;
  }

  .report-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    padding: 5mm;
    box-sizing: border-box;
  }

  .no-border {
    border: none !important;
  }
}

.report-container {
  width: 100%;
  margin: 0 auto;
  padding: 16px;
}

.logo {
  width: 100px;
}

.report-table-line {
  th, td {
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
  }
}

.no-border {
  border: none !important;
}

.negative-value {
  color: #dc2626;
}
</style>
